import { Language } from '@ha/intl';

const availableLocales = [Language.nl, Language.de];

const hasLandlordsCommunity = (lang: Language) =>
  availableLocales.includes(lang);
export { hasLandlordsCommunity };
